import Layout from "../components/Layout";
import { useAuth } from "../contexts/AuthContext";
import { FileSpreadsheet, Calculator, Mic2, Search } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { CriadorRoteiro } from "../components/tools/CriadorRoteiro";
import { AnalisadorPersonagens } from "../components/tools/AnalisadorPersonagens";
import { CalculadoraOrcamento } from "../components/tools/CalculadoraOrcamento";
import { OrganizacaoDubladores } from "../components/tools/OrganizacaoDubladores";

const Tools = () => {
  const { user, getAuthHeaders } = useAuth();

  if (user?.role === "dublador") {
    return (
      <Layout>
        <div className="flex items-center justify-center h-96" data-testid="tools-access-denied">
          <div className="text-center">
            <p className="text-2xl text-red-400 font-bold mb-2">Acesso Restrito</p>
            <p className="text-slate-400">Você não tem permissão para acessar esta página.</p>
          </div>
        </div>
      </Layout>
    );
  }

  const isVisitante = user?.role === "visitante";

  const allTabs = [
    { value: "roteiro",     label: "Criador de Roteiro", Icon: FileSpreadsheet, Component: CriadorRoteiro },
    { value: "calculadora", label: "Calculadora",        Icon: Calculator,      Component: CalculadoraOrcamento },
    { value: "organizacao", label: "Organização",        Icon: Mic2,            Component: OrganizacaoDubladores },
    { value: "analisador",  label: "Analisador",         Icon: Search,          Component: AnalisadorPersonagens },
  ];

  // Visitante has read-limited access — only Criador de Roteiro and Analisador.
  const tabConfig = isVisitante
    ? allTabs.filter(t => t.value === "roteiro" || t.value === "analisador")
    : allTabs;

  return (
    <Layout>
      <div className="p-4 md:p-8 space-y-6" data-testid="tools-page">
        <div>
          <h1 className="text-3xl md:text-4xl font-bold text-white">Ferramentas</h1>
          <p className="text-slate-400 mt-1">Utilitários internos do estúdio</p>
        </div>

        <Tabs defaultValue="roteiro" className="w-full">
          <TabsList
            className="bg-slate-800/50 border border-slate-700 p-1 rounded-lg w-full sm:w-auto"
            data-testid="tools-tabs"
          >
            {tabConfig.map(({ value, label, Icon }) => (
              <TabsTrigger
                key={value}
                value={value}
                className="data-[state=active]:bg-teal-600 data-[state=active]:text-white text-slate-400 rounded-md px-4"
                data-testid={`tab-${value}`}
              >
                <Icon className="w-4 h-4 mr-2" /> {label}
              </TabsTrigger>
            ))}
          </TabsList>

          {tabConfig.map(({ value, Component }) => (
            <TabsContent key={value} value={value} className="mt-6">
              <Component getAuthHeaders={getAuthHeaders} />
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </Layout>
  );
};

export default Tools;
